import React from 'react';
import { ReactComponent as CheckCollapsible } from '../../assets/images/icons/checkCollapsible.svg';

export default function CheckCollapsibleIcon(props) {
  return (
    <CheckCollapsible className={`icon ${props.className}`} />
  );
}
